import { useEffect } from 'react';
import { AppRouter } from './router';
import { AppProvider } from './providers/provider';
import {
  attachAuthInterceptor,
  attachSessionResetInterceptor,
} from '~shared/api/api.instance';
import { configureApiClient } from '~shared/api/api-client';
import { store } from '~shared/store';
import { queryClient } from '~shared/query-client';
import { sessionActions } from '~entities/session/model/session.slice';
import { SESSION_ROOT_QUERY_KEY } from '~entities/session/api/session.queries';
import { initializeFocusDetection } from '~shared/lib/accessibility/focus-detection';

const getSessionId = () => store.getState().session?.sessionId;
const resetSession = () => {
  store.dispatch(sessionActions.resetSession());
  queryClient.invalidateQueries({ queryKey: SESSION_ROOT_QUERY_KEY });
};

// Wire both transports (legacy axios + the openapi-fetch client) with the same
// session source + stale-session reset during the migration.
attachAuthInterceptor(getSessionId);
attachSessionResetInterceptor(resetSession);
configureApiClient({ getSessionId, onStaleSession: resetSession });

export const App = () => {
  // Initialize focus detection on mount
  useEffect(() => {
    const cleanup = initializeFocusDetection();
    return cleanup;
  }, []);

  return (
    <AppProvider>
      <AppRouter />
    </AppProvider>
  );
};
